import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 1679,
	height: 282,
	fill: "none",
	viewBox: "0 0 1679 282",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#56719A",
		d: "M1560 46 1679 .5V282H0V27s148.9 37.1 343.3 56.28c43.52 4.3 115 7.22 115 7.22l86.88 30s150.07-3.97 250.45.67c109.8 5.06 284.52-7.76 284.52-7.76l162.7-1.46h32.37l39.19-8.21h22.15l155.7-33.33L1560 46Z"
	})
});
const SvgMountainsBg = styled(base)({});
export default SvgMountainsBg;
